up.compiler('[data-header-search-toggle]', (element) => {
  element.addEventListener('click', () => {
    up.emit('app.headerSearch.show')
  })
})
